import React from 'react'
import ServicesTemplate from '../../templates/Services/ServicesTemplate'

const Services = () => {
  return (
     <ServicesTemplate />
  )
}

export default Services